
import OpenAI from 'openai';

const OPENAI_API_KEY = import.meta.env.VITE_OPENAI_API_KEY;

const openai = new OpenAI({
  apiKey: OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export async function analyzeWithAI(data) {
  try {
    const systemPrompt = `Você é AXIS, uma IA especialista em endocrinologia e análise hormonal.

DADOS DO PACIENTE:
${formatPatientData(data)}

RESULTADOS LABORATORIAIS:
${formatLabResults(data.examValues)}

ANÁLISE DA CALCULADORA:
${formatCalculatorAnalysis(data.analysisResults)}

DIRETRIZES:
1. Forneça análises precisas e baseadas em evidências
2. Use linguagem clara e acessível
3. Cite referências médicas atualizadas
4. Indique quando necessário avaliação médica
5. Explique correlações hormonais
6. Sugira exames complementares quando relevante
7. Alerte sobre padrões atípicos

RESPONDA:
${data.userQuery || "Analise estes resultados em detalhes, explicando as correlações e possíveis implicações clínicas."}`;

    const completion = await openai.chat.completions.create({
      model: "gpt-4",
      messages: [
        {
          role: "system",
          content: systemPrompt
        }
      ],
      temperature: 0.3,
      max_tokens: 2000
    });

    return {
      status: "success",
      content: completion.choices[0].message.content,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error("AI Analysis Error:", error);
    throw new Error(`Falha na análise: ${error.message}`);
  }
}

function formatPatientData(data) {
  return `
Gênero: ${data.gender}
Idade: ${data.age || "Não informada"}
Tipo de Análise: ${data.calculatorType}
${data.symptoms ? `Sintomas: ${JSON.stringify(data.symptoms, null, 2)}` : ""}
${data.clinicalData ? `Dados Clínicos: ${JSON.stringify(data.clinicalData, null, 2)}` : ""}`;
}

function formatLabResults(examValues) {
  if (!examValues) return "Sem dados laboratoriais";
  
  return Object.entries(examValues)
    .map(([hormone, value]) => `${hormone}: ${value}`)
    .join('\n');
}

function formatCalculatorAnalysis(results) {
  if (!results) return "Sem análise disponível";
  
  return `
Status: ${results.status || 'N/A'}
Severidade: ${results.severity || 'N/A'}
Correlações: ${JSON.stringify(results.correlations || [], null, 2)}
Recomendações: ${JSON.stringify(results.recommendations || [], null, 2)}`;
}

export function validateResults(examValues, gender) {
  // Implementa validações específicas por gênero e tipo de exame
  const validations = [];
  
  if (gender === "Masculino") {
    if (examValues.testosterona < 240 && examValues.lh < 8) {
      validations.push("Padrão atípico: Testosterona baixa sem elevação adequada de LH");
    }
  } else {
    if (examValues.estradiol < 30 && examValues.fsh < 20) {
      validations.push("Padrão atípico: Estradiol baixo sem elevação adequada de FSH");
    }
  }
  
  return validations;
}
